export default require('./ChapterProgress').default
